<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'الطلاب المقبولين'" :to="{name: 'students'}">  الطلاب المقبولين</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">



                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                        إدارة الطلاب المقبولين
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                     
                                        <li class="list-inline-item">
                                                 <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1" v-if="searchingMode == 0" @click="searchingMode = 1"><span>فلاتر البحث</span></button>
                                <button class="btn btn-danger search-btn-wg mb-2 my-2" v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button>

                                </li>



                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">


                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-4">
                                          <label for="">الاسم</label>
                                          <v-select v-model="data.searching.name" :options="options" @search="onSearchName" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">المرحلة الدراسية</label>
                                          <treeselect :options="stages" v-model="data.searching.stage_id" @select="getGroups" :multiple="false" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">الصف الدراسى</label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" :multiple="false" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">الحلقة</label>
                                          <treeselect :options="lessons" v-model="data.searching.lesson_id" :multiple="false" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">المعلم</label>
                                          <v-select v-model="teacher"  @option:selected="setInputLesson" :options="teachers" @search="onSearchTeacher" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">المشرفين</label>
                                          <v-select v-model="supervisor"  @option:selected="setInputSuper" :options="supervisors" @search="onSearchSupervisor" />
                                        </div>
                                        <div class="col-md-6">
                                          <label for="">اسم ولى الامر</label>
                                          <input type="text" class="form-control" v-model="data.searching.parent_name">
                                        </div>
                                        <div class="col-md-6">
                                          <label for="">رقم الهوية</label>
                                          <input type="text" class="form-control" v-model="data.searching.id_number">
                                        </div>
                                        <div class="col-md-12">
                                          <label for="">المصروفات</label>
                                          <div class="row">
                                            <div class="col-md-3">
                                              <input type="radio" value="" class="" v-model="data.searching.payments" >الكل
                                            </div>
                                            <div class="col-md-3">
                                              <input type="radio" value="الصف الاول" class="" v-model="data.searching.payments" > الصف الاول
                                            </div>
                                            <div class="col-md-3">
                                              <input type="radio" value="الصف الثانى" class="" v-model="data.searching.payments" > الصف الثانى
                                            </div>
                                            <div class="col-md-3">
                                              <input type="radio" value="الصف الثالث" class="" v-model="data.searching.payments" > الصف الثالث
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-4 mt-2">
                                                                      <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                          <!-- <input type="submit" name="time" class=" btn btn-button-7 btn-block" value="بــــحــث"> -->
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                   <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                          
                                        <table class="table table-bordered mb-4">
                                            <thead>
                                                <tr>
                                                    <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">الاسم</th>
                                                    <th @click="resortData();">المرحلة الدراسية</th>
                                                    <th @click="resortData();">الصف الدراسى</th>
                                                    <th @click="resortData();">المعلم</th>
                                                    <th @click="resortData();">رقم الواتس آب</th>
                                                    <th @click="resortData();">تم دفع الرسوم</th>
                                                    <th @click="resortData();">الرسوم الفعلية</th>
                                                    <th @click="resortData();">الرسوم المدفوعة</th>
                                                    <th @click="resortData();">الرسوم المتبقية</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in data.data" :key="index">
                                                    <td>{{item.id}}</td>
                                                    <td>{{item.name}}</td>
                                                    <td>{{item.stage ? item.stage.name : '---'}}</td>
                                                    <td>{{item.group ? item.group.name : '---'}}</td>
                                                    <td>{{item.teacher ? item.teacher.name : '---'}}</td>
                                                    <td>{{item.whatsapp}}</td>
                                                    <td>{{item.fees ? (item.fees.stage_id == item.stage_id && ( (item.stage ? item.stage.fees : 0) -  (item.stage_total_cost ? item.stage_total_cost : 0) <= 0 ) ? 'نعم' : 'لا') : 'لا' }}</td>
                                                    <td>{{item.stage ? item.stage.fees : '0' }}</td>
                                                    <td>{{item.stage_total_cost ? item.stage_total_cost : '0' }}</td>
                                                    <td>{{ (item.stage ? item.stage.fees : 0) -  (item.stage_total_cost ? item.stage_total_cost : 0) }}</td>
                                                    <td class="text-center">

                                                        <div class="dropdown custom-dropdown">
                                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i class="flaticon-dot-three fs-17"></i>
                                                            </a>

                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                                <a href="#" class="dropdown-item" @click.prevent="print(item)">طباعة</a>
                                                                <edit-button v-if="hasPermissions('students_edit')" :routing="{name: 'students.edit', params: {id: item.id}}"></edit-button>
                                                                <delete-button v-if="hasPermissions('students_delete')" :deleteUrl="'/students/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                                <router-link class="dropdown-item" title="خطة الحفظ والمراجعة" :to="{name: 'saveReviewPlans.create', query: {student_id: item.id}}">
                                                                  <span >خطة الحفظ والمراجعة</span>
                                                                </router-link>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">الاسم</th>
                                                    <th @click="resortData();">المرحلة الدراسية</th>
                                                    <th @click="resortData();">الصف الدراسى</th>
                                                    <th @click="resortData();">المعلم</th>
                                                    <th @click="resortData();">رقم الواتس آب</th>
                                                    <th @click="resortData();">تم دفع الرسوم</th>
                                                     <th @click="resortData();">الرسوم الفعلية</th>
                                                    <th @click="resortData();">الرسوم المدفوعة</th>
                                                    <th @click="resortData();">الرسوم المتبقية</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>

                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
              <div class="row" style="display: none;" id="printMe">
                <div class="col-md-12">
                   <table class="table table-bordered">
                <tbody>
                  <tr class="text-center">
                    <th colspan="4">
                      استمارة بيانات معلم<br>
                      (السيرة الذاتية)
                    </th>
                  </tr>
                </tbody>
                <tbody>
                  <tr class="text-center">
                    <td colspan="4" style="color: white;background: black">
                      البيانات الشخصية
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">الاسم</td>
                    <td colspan="2">{{printData.name}}</td>
                  </tr>
                  <tr>
                    <td>تاريخ الميلاد</td>
                    <td>{{printData.birth_date}}</td>
                    <td>مكان الميلاد</td>
                    <td>{{printData.birth_place}}</td>
                  </tr>
                  <tr>
                    <td>المرحلة الدراسية</td>
                    <td>{{printData.stage ? printData.stage.name : '---' }}</td>
                    <td>الصف</td>
                    <td>{{printData.group ? printData.group.name : '---' }}</td>
                  </tr>
                   <tr>
                    <td colspan="2">الحلقة</td>
                    <td colspan="2">{{printData.lesson ? printData.lesson.name : '---' }}</td>
                  </tr>
                  <tr>
                    <td colspan="2">اسم المعلم حلقة واحدة</td>
                    <td colspan="2">{{printData.teacher ? printData.teacher.name : '---' }}</td>
                  </tr>
                  <tr>
                    <td colspan="2">اسم المشرف التربوى اكثر من حلقة</td>
                    <td colspan="2">{{printData.supervisor ? printData.supervisor.name : '---' }}</td>
                  </tr>
                  <tr>
                    <td colspan="2">تاريخ التسجيل</td>
                    <td colspan="2">
                      {{ printData.register_date }}
                    </td>
                  </tr>
                  <tr>
                    <td>الحلة الاجتماعية</td>
                    <td>
                      {{ printData.marital_status }}
                    </td>
                    <td>حالة الطالب</td>
                    <td>
                      {{ printData.student_status }}
                    </td>
                  </tr>


                  <tr class="text-center">
                    <td colspan="4">معلومات الهوية</td>
                  </tr>
                  <tr>
                    <td>رقم الهوية</td>
                    <td>{{printData.id_number}}</td>
                    <td>مصدرها</td>
                    <td>{{printData.id_place}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">نوع الهوية</td>
                    <td colspan="2">{{printData.id_type}}</td>
                  </tr>
                  <tr>
                    <td>تاريخها</td>
                    <td>{{printData.id_date}}</td>
                    <td>تاريخ الانتهاء</td>
                    <td>{{printData.id_expire_date}}</td>
                  </tr>

                   <tr class="text-center">
                    <td colspan="4">
                      معلومات الاتصال
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">عنوان المنزل</td>
                    <td colspan="2">{{printData.address}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">رقم الهاتف 1</td>
                    <td colspan="2">{{printData.phone1}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">رقم الهاتف 2</td>
                    <td colspan="2">{{printData.phone2}}</td>
                  </tr>
                  <tr>
                    <td>رقم الجوال</td>
                    <td>{{printData.mobile}}</td>
                    <td>رقم الواتس آب</td>
                    <td>{{printData.whatsapp}}</td>
                  </tr>
                  <tr>
                    <td  colspan="2">البريد الإلكتروني</td>
                    <td  colspan="2">{{printData.email}}</td>
                  </tr>

                  <tr class="text-center">
                    <td colspan="4">معلومات العمل</td>
                  </tr>
                  <tr>
                    <td colspan="2">العمل </td>
                    <td colspan="2">{{printData.work}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">العنوان</td>
                    <td colspan="2">{{printData.work_address}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">الهاتف</td>
                    <td colspan="2">{{printData.work_phone}}</td>
                  </tr>

                  <tr class="text-center">
                    <td colspan="4">معلومات ولى الامر</td>
                  </tr>
                  <tr>
                    <td colspan="2">اسم ولى الامر</td>
                    <td colspan="2">
                     {{printData.parent_name}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">عمل ولى الامر</td>
                    <td colspan="2">
                     {{printData.parent_work}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">هاتف عمله</td>
                    <td colspan="2">
                     {{printData.parent_work_phone}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">جواله</td>
                    <td colspan="2">
                     {{printData.parent_mobile}}
                    </td>
                  </tr>
                   <tr>
                    <td colspan="2">صلة القرابة</td>
                    <td colspan="2">
                     {{printData.parent_relation}}
                    </td>
                  </tr>

                  <tr class="text-center">
                    <td colspan="4">صورة الهوية و صورة شخصية</td>
                  </tr>
                  <tr>
                    <td colspan="4">صورة الهوية</td>
                  </tr>
                  <tr>
                    <td colspan="4"><img :src="printData.image_id_path" style="width: 100%; height: 350px" alt=""></td>
                  </tr>
                  <tr>
                    <td colspan="4">صورة شخصية</td>
                  </tr>
                  <tr>
                    <td colspan="4"><img :src="printData.image_path" style="width: 100%; height: 350px" alt=""></td>
                  </tr>
                </tbody>
              </table>
                </div>
              </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    Treeselect
  },
  data() {
    return {
      printData: {
        experience: [],
        courses: [],
        quaran: []
      },
      data: {
        data: {},
        searching:{
            id: '',
            name: '',
            lesson_id: '',
            group_id: '',
            stage_id: '',
            teacher_id: '',
            supervisor_id: '',
            parent_name: '',
            id_number: '',
            payments: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       name: '',
       stages: [],
       stage: '',
       groups: [],
       group: '',
       lessons: [],
       lesson: '',
       supervisors: [],
       supervisor: '',
       teachers: [],
       teacher: '',
       searchingMode: 0
    };
  },
  created(){
      this.flashAlert();
      this.search(null, '', this, 'supervisors');
      this.search(null, '', this, 'name');
      this.search(null, '', this, 'groups');
      this.search(null, '', this, 'stages');
      this.search(null, '', this, 'lessons');
      this.search(null, '', this, 'teachers');
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    printTable(){
      setTimeout(() => {
        this.print_element('print-table', 'الطلاب');
      }, 1000);
    },
    print(data){
      this.printData = data;
      setTimeout(() => {
      this.print_element('printMe', 'طالب');

      }, 1000);
    },
    setInputStage(op){
      this.data.searching.stage_id = op.id;
    },
    setInputGroup(op){
      this.data.searching.group_id = op.id;
    },
     setInputLesson(op){
      this.data.searching.lesson_id = op.id;
    },
    setInputTeacher(op){
      this.data.searching.teacher_id = op.id;
    },
    setInputSuper(op){
      this.data.searching.supervisor_id = op.id;
    },
    onSearchName(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'name');
      }
    },

    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'groups');
      }
    },

    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stages');
      }
    },

    onSearchLesson(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'lessons');
      }
    },
    onSearchTeacher(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'teachers');
      }
    },

    onSearchSupervisor(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'supervisors');
      }
    },

    getGroups(val){
      this.$baseApi.get('/students?option=group&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.lessons = response.data.data.lessons;
              this.groups = response.data.data.groups;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },

    search(loading, w, vm, mod){
      this.$baseApi.get('/students?pluck=1&search='+w+'&mod='+mod).then((response)=>{
                  if(loading){
                  loading(false);
                  }
            if(response.data.code == 200){
              let options = response.data.data.options;
              if(mod == 'name'){
                this.options = options;
              }else if(mod == 'stages'){
                this.stages = options;
              }else if(mod == 'groups'){
                this.groups = options;
              }else if(mod == 'teachers'){
                this.teachers = options;
              }else if(mod == 'supervisors'){
                this.supervisors = options;
              }else{
                this.lessons = options;
              }

            }else{
                alert(response.data.error.error);
            }
        });
    },

    makeChangeOnStatus(k, item){
      this.$baseApi.get('/students', {
                    params: {student: item.id, payments: item.statuses}
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.data[k] = response.data.data.student;
               item.edit = 0;

            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        this.$baseApi.get('/students?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
                  console.log(response.data.data)
            if(response.data.code == 200){
               this.data.paginated = response.data.data.students;
               this.data.data = response.data.data.students.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
